module.exports = __webpack_public_path__ + "static/img/cherry-m.855c947.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/cherry-m.jpg
// module id = +T0M
// module chunks = 0